export default (api, resource) => ({


    getAll: async({token,rota,params})=>{

        let url = `${resource}`

        if(rota && rota === "porSorteio"){
            url = `${url}/por-sorteio`
        }

        if(rota && rota === "porSecao"){
            url = `${url}/por-cidade`
        }

        if(rota && rota === "porEstabelecimento"){
            url = `${url}/por-estabelecimento`
        }

        const response = await api.get( url,{
            params,
            headers:{
                Authorization: token
            }
        })

        return{
            data: response.data 
        }
    },

    // Uso da TV: dias ligada x desligada por ponto (so admin e gestor de regiao)
    usoTv: async({token,params})=>{
        const response = await api.get(`${resource}/uso-tv`,{
            params,
            headers:{ Authorization: token }
        })
        return { data: response.data.data }
    },

    usoTvDetalhe: async({token,estabelecimentoId,params})=>{
        const response = await api.get(`${resource}/uso-tv/${estabelecimentoId}`,{
            params,
            headers:{ Authorization: token }
        })
        return { data: response.data.data }
    },

})